import { render, staticRenderFns } from "./FileTransferRoot.vue?vue&type=template&id=2cc7c44f"
import script from "./FileTransferRoot.vue?vue&type=script&lang=ts"
export * from "./FileTransferRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports